<div class="metric-card" (click)="navigate()">
    <div class="metric-card__header">
        <div>
            <span class="metric-card__title">{{ title }}</span>
            <div class="metric-card__value">{{ value }}</div>
        </div>
        <div class="metric-card__icon" [ngClass]="statusBgClass">
            <i class="pi" [ngClass]="[icon, statusTextClass]"></i>
        </div>
    </div>

    <ng-container *ngIf="subtitle">
        <span class="metric-card__subtitle">{{ subtitle }}</span>
    </ng-container>
</div>
